import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useAuthHeader } from 'react-auth-kit';
import './App.css';

const NONE = '';

// Admin/volunteer control for choosing which game(s) show on the public
// /display page. Zero, one, or two games can be live at a time.
const LiveDisplayControl = () => {
   const authHeader = useAuthHeader();
   const [gameOptions, setGameOptions] = useState([]);
   const [board1, setBoard1] = useState(NONE);
   const [board2, setBoard2] = useState(NONE);
   const [status, setStatus] = useState(null);
   const [loading, setLoading] = useState(true);

   useEffect(() => {
      const loadState = async () => {
         try {
            const [gamesRes, activeRes] = await Promise.all([
               axios.get('/games/current'),
               axios.get('/games/active'),
            ]);
            setGameOptions(gamesRes.data || []);

            const active = activeRes.data.activeGames || [];
            setBoard1(active[0] ? String(active[0].id) : NONE);
            setBoard2(active[1] ? String(active[1].id) : NONE);
         } catch (err) {
            console.error('Failed to load live display state:', err);
            setStatus({ text: 'Failed to load current live display state.', type: 'error' });
         } finally {
            setLoading(false);
         }
      };

      loadState();
   }, []);

   const handleSave = async (e) => {
      e.preventDefault();

      const gameIds = [board1, board2]
         .filter((id) => id !== NONE)
         .map((id) => Number(id));

      try {
         await axios.post('/games/active', { gameIds }, {
            headers: { Authorization: authHeader() },
         });
         setStatus({
            text: gameIds.length === 0
               ? 'Live display cleared. No game is showing.'
               : `Live display updated: ${gameIds.length} game(s) now showing.`,
            type: 'success',
         });
      } catch (err) {
         console.error(err);
         const msg = err.response?.data?.error ?? 'Could not reach the server.';
         setStatus({ text: msg, type: 'error' });
      }
   };

   if (loading) {
      return <p>Loading live display control...</p>;
   }

   return (
      <div className="main-style">
         <form className="player-entry-form" onSubmit={handleSave}>
            <p>
               Choose which game(s) appear on the public live display
               (<code>/display</code>). Leave a slot on "None" to show fewer boards.
            </p>

            {status && (
               <div className={status.type === 'success' ? 'success-message' : 'error-message'}>
                  {status.text}
               </div>
            )}

            <div className="margin-top-medium">
               <label className="form-label" htmlFor="board1">Board 1:</label>
               <select
                  className="form-select"
                  id="board1"
                  value={board1}
                  onChange={(e) => setBoard1(e.target.value)}
               >
                  <option value={NONE}>-- None --</option>
                  {gameOptions.map((game) => (
                     <option key={game.id} value={game.id}>{game.displayName}</option>
                  ))}
               </select>
            </div>

            <div className="margin-top-small">
               <label className="form-label" htmlFor="board2">Board 2:</label>
               <select
                  className="form-select"
                  id="board2"
                  value={board2}
                  onChange={(e) => setBoard2(e.target.value)}
               >
                  <option value={NONE}>-- None --</option>
                  {gameOptions.map((game) => (
                     <option key={game.id} value={game.id}>{game.displayName}</option>
                  ))}
               </select>
            </div>

            <div className="margin-top-medium">
               <button className="btn-base" type="submit">Update Live Display</button>
               <a
                  className="btn-standard"
                  style={{ marginLeft: '10px' }}
                  href="/display"
                  target="_blank"
                  rel="noopener noreferrer"
               >
                  Open Live Display
               </a>
            </div>
         </form>
      </div>
   );
};

export default LiveDisplayControl;
